import * as React from 'react';
import { RecordCellSet } from 'domain/journal/helper';

import elements from 'components/elements';
import { EVENTS } from 'components/Tables/fsm';

import { prepareText } from 'components/Tables/textProccess';
import { Map } from 'immutable';

import Tooltip from 'components/mui/Tooltip';
import { CellRoot, CellRendererInput, CellRendererValue } from 'components/Tables/Cells/Cell/StyledComponents';

import cx from 'classnames';

const POLYGON = 'POLYGON';
const MULTI_POLYGON = 'MULTI_POLYGON';
const GRID = 'GRID';

class CellRenderer extends React.Component {
  static defaultProps = {
    hintDisabled: false,
  };

  state = {
    active: false,
  };

  onMouseUp = () => {
    const { reference } = this.props;
    const ref = reference.first();
    if (ref) {
      const { type, polygonId, text } = ref;
      const dropParams =
        type === 'POLYGON'
          ? { type: 'POLYGON', payload: { id: polygonId, text } }
          : { type: 'MULTI_POLYGON', payload: { text } };
      this.handleDrop(dropParams);
    }
  };

  get preventEventForChars() {
    const { hotkeyList } = this.props;
    // 9 - tab
    const preventedChars = [9];

    hotkeyList.forEach((item) =>
      item.keys.forEach((keys) => {
        if (keys.includes('F7')) {
          preventedChars.push(118);
        }
      }),
    );
    return preventedChars;
  }

  get celleStyle() {
    return this.props.data.style.toJS();
  }

  get isActiveCall() {
    return this.state.active;
  }

  get value() {
    const { value } = this.props;
    return value || undefined;
  }

  get hint() {
    const {
      data: { hint },
    } = this.props;
    return hint || this.value;
  }

  get initialValue() {
    const { initValue, cellSet } = this.props.data;
    return cellSet.value === initValue;
  }

  handleDrop = (d) => {
    const { isSupport, createRefernce, data, setActiveCell } = this.props;

    if (isSupport === false) {
      this.handleDragLeave();
      return;
    }

    if (data.has('isCreatable') && (POLYGON === d.type || MULTI_POLYGON === d.type)) {
      this.props.eventCollector(EVENTS.onDrop, d.payload.text);
      setActiveCell(data._cell);
      this.handleDragLeave();
      return;
    }

    if (d.type === MULTI_POLYGON) {
      createRefernce({ cell: data._cell, text: prepareText(data, d), isMulti: true });
    }

    if (d.type === POLYGON) {
      createRefernce({ cell: data._cell, text: prepareText(data, d), isMulti: false });
    }

    if (d.type === GRID) {
      this.props.insertGrid(d.payload, { id: data._cell, name: data.name });
    }

    this.handleDragLeave();
  };

  handleDragEnter = () => {
    if (this.props.isSupport === false) return;
    const { activeReference } = this.props;
    const { active } = this.state;
    if (!active && activeReference) {
      this.setState({ active: true });
    }
  };

  handleDragLeave = () => {
    if (this.props.isSupport === false) return;
    this.setState({ active: false });
    const {
      activeReference,
      setActiveReference,
      data: { _cell },
    } = this.props;
    if (activeReference && activeReference.cell === _cell) {
      const params = activeReference.set('x2', null).set('y2', null);
      setActiveReference({ id: params.id, params });
    }
  };

  handleChange = (event) => {
    const { data, onChange, maxLength } = this.props;
    const {
      currentTarget: { value },
    } = event;
    const newValue = value.slice(0, maxLength);
    if (data.type === 'index_list' || data.type === 'paginated_list' || data.type === 'paginated_multiselect_list') {
      this.props.eventCollector(EVENTS.onPast, newValue);
    } else if (data.cellSet.value !== newValue) {
      onChange(data._cell, RecordCellSet({ value: newValue === '' ? null : newValue }));
    }
  };

  element;

  proxyFocus = (e) => {
    const { value } = this.props;
    this.props.handleFocus();
    if (typeof value === 'string') {
      e.currentTarget.setSelectionRange(0, value.length);
    }
  };

  proxyRef = (el) => {
    this.props.buttonRef(el);
    if (el) {
      this.element = el;
    }
  };

  handleKey = (e) => {
    if (this.preventEventForChars.includes(e.keyCode)) {
      e.preventDefault();
    }
    this.props.handleKey(e);
  };

  render() {
    const { data, className, maxLength, value, children } = this.props;
    return (
      <CellRoot
        role="button"
        tabIndex="0"
        onMouseOver={this.handleDragEnter}
        onMouseEnter={this.handleDragEnter}
        onMouseLeave={this.handleDragLeave}
        onMouseUp={this.onMouseUp}
        onFocus={(e) => e.preventDefault()}
        className={cx(className, 'droppable')}
      >
        {/* TODO uncomment after fix performance */}
        <Tooltip t={data.hint || this.value} disableFocusListener>
          <CellRendererInput
            type="text"
            value={this.value}
            ref={this.proxyRef}
            maxLength={maxLength}
            onFocus={this.proxyFocus}
            onBlur={this.props.handleBlur}
            onClick={this.props.handleClick}
            onDoubleClick={this.props.handleDoubleClick}
            onKeyDown={this.handleKey}
            onChange={this.handleChange}
            data-element={elements.je.fakeCell.container}
            data-element-id={`${data._cell}-${data.type}`}
          />
        </Tooltip>
        <CellRendererValue
          className={cx({
            'je-cell-drag-available': this.isActiveCall,
            'je-cell-init-value': this.initialValue,
            [`je-cell-type-${data.type}`]: true,
            'je-cell-fake-value': true,
          })}
          style={this.celleStyle}
          data-element={elements.je.fakeCell.value}
        >
          {value}
        </CellRendererValue>
        {children}
      </CellRoot>
    );
  }
}

export default CellRenderer;
